const setGuideSliderHeight = (sliderItems, activeIndex = 0) => {
  if (!sliderItems || sliderItems.length === 0) return;

  const sliderParent = sliderItems.first().closest('.ug-slider-parent, .ug-additional-slider-parent');
  const sliderItemsParent = sliderParent.find('.ug-slider-items-parent, .ug-additional-slider-items-parent').first();
  const sliderItemsList = sliderParent.find('.ug-slider-items-list, .ug-additional-slider-items-list').first();
  const targetSlide = sliderItems.eq(activeIndex).length ? sliderItems.eq(activeIndex) : sliderItems.first();
  const targetHeight = targetSlide.outerHeight(true);

  if (!targetHeight) return;

  gsap.set(sliderItemsParent, { height: targetHeight });
  gsap.set(sliderItemsList, { height: targetHeight });
};

const animateSlider = (slider, sliderObject, direction, from, to, additionalSliderObject = undefined) => {
  const prevStep = sliderObject.eq(from);
  const nextStep = sliderObject.eq(to);
  const excludedSteps = prevStep.add(nextStep);
  const remainingSteps = sliderObject.not(excludedSteps);

  if(additionalSliderObject){
    const additionPrevStep = additionalSliderObject.eq(from);
    const additionalNextStep = additionalSliderObject.eq(to);
    const additionalExcludedSteps = additionPrevStep.add(additionalNextStep);
    const additionalRemainingSteps = additionalSliderObject.not(additionalExcludedSteps);

    gsap.to(additionalExcludedSteps, {
      x: `${-100 * to}%`,
      duration: 1,
      ease: 'pageInEasing',
      stagger: {
        each: 0.1,
        from: direction == 1 ? 'start' : 'end',
      },
      onComplete: () => {
        slider.attr('data-is-blocked', 'none');
        setGuideSliderHeight(additionalSliderObject, to);
      },
    });
    gsap.set(additionalRemainingSteps, {
      x: `${-100 * to}%`,
    });
  }
  
  gsap.to(excludedSteps, {
    x: `${-100 * to}%`,
    duration: 1,
    ease: 'pageInEasing',
    stagger: {
      each: 0.1,
      from: direction == 1 ? 'start' : 'end',
    },
    onComplete: () => {
      slider.attr('data-is-blocked', 'none');
      setGuideSliderHeight(sliderObject, to);
    },
  });
  gsap.set(remainingSteps, {
    x: `${-100 * to}%`,
  });
};

$(window).on('load', function () {
  const sliderParents = $('.ug-slider-parent');
  sliderParents.each(function () {
    const ugSlider = $(this).find('.ug-slider-item-parent');
    const ugSliderNav = $(this).find('.slider-nav-parent');
    const ugAdditionalSlider = $(this).closest('.ug-step-parent').find('.ug-additional-slider-parent');
    ugSliderNav.attr('data-current-step', 0);
    setGuideSliderHeight(ugSlider, 0);
    if (ugSliderNav.length != 0) {
      if(ugAdditionalSlider.length != 0){
        const ugAdditionalSliderItems = ugAdditionalSlider.find('.ug-slider-item-parent');
        setGuideSliderHeight(ugAdditionalSliderItems, 0);
        addStepAnimation(ugSliderNav, ugSlider, animateSlider, ugAdditionalSliderItems);
      } else {
        addStepAnimation(ugSliderNav, ugSlider, animateSlider);
      }
      addSliderInAnimation(ugSliderNav, false).progress(1);
    }
  });

  $(window).on('deviceChange', function () {
    sliderParents.each(function () {
      const ugSlider = $(this).find('.ug-slider-item-parent');
      const ugSliderNav = $(this).find('.slider-nav-parent');
      const ugAdditionalSlider = $(this).closest('.ug-step-parent').find('.ug-additional-slider-parent');
      const currentStep = parseInt(ugSliderNav.attr('data-current-step') || '0', 10);
      setGuideSliderHeight(ugSlider, currentStep);
      if (ugAdditionalSlider.length != 0) {
        const ugAdditionalSliderItems = ugAdditionalSlider.find('.ug-slider-item-parent');
        setGuideSliderHeight(ugAdditionalSliderItems, currentStep);
      }
    });
  });
});
